import { Environment } from './environment';
import { InjectionToken } from '@angular/core';

export const APP_VERSION = new InjectionToken<{ version: string; buildNumber: string }>('version');
export const APP_ENVIRONMENT = new InjectionToken<Environment>('environment');
